<bizz-file-select-multi #MailingAttachmentsUploadComponentFileSelect
                        (filesSelected)="filesDropped($event)"></bizz-file-select-multi>
<div bizz-drag-drop
     class="flex h-auto flex-col rounded border-2 border-dashed px-4 py-2"
     [class.py-4]="mode=='checklists'"
     [class.border-blue-500]="isHoveringDragDrop"
     [class.bg-blue-50]="isHoveringDragDrop"
     (files)="filesDropped($event)"
     (isHoveringDragDrop)="isHoveringDragDrop = $event"
     [class.border-form-control]="!isHoveringDragDrop"
     [class.bg-section]="!isHoveringDragDrop"
     [class.hidden]="readonly"
     [ngClass]="{'bg-blue-500/20 border-blue-500' : isHoveringDragDrop}" #attachmentSelector>
    <div class="relative flex items-center justify-evenly gap-2 sm:gap-4" [class.!justify-center]="mode=='checklists'">
        <!-- Dropzone-->

        <div class="flex cursor-pointer items-center justify-center gap-5" [class.pointer-events-none]="readonly"
             (click)="openFileSelect();">
            <bizz-icon
                    class="mx-1 block h-auto min-w-6 text-blue-500"
                    iconName="cloud-arrow-up"
                    [hover]="true">
            </bizz-icon>
            <p class="select-none text-xs sm:text-sm">{{ "DropOrUploadFile" | translate }}</p>
        </div>
        @if ((mode !== 'checklists') && (media$ | async); as media ) {
            <div class="flex items-center justify-center">
                <div class="my-2 h-8 w-1 rounded bg-divider-handle">
                </div>
            </div>

            <div class="flex cursor-pointer items-center justify-center gap-5"
                 (click)="togglePopup(media)"
                 #anchorParent>
                <bizz-icon
                        class="mx-1 block h-auto min-w-6 text-blue-500"
                        iconName="file-circle-plus"
                        [hover]="true">
                </bizz-icon>
                <p class="select-none text-xs sm:text-sm">
                    {{ "AddAttachmentFromTheCurrentForm" | translate }}
                    <bizz-icon class="mx-1 h-5 w-4 items-center align-middle transition-transform" iconName="caret-down"
                               [ngClass]="{'rotate-180': showPopup }"></bizz-icon>
                    <br>
                </p>
            </div>
            @if (showPopup) {
                <kendo-popup
                        [anchor]="attachmentSelector"
                        [margin]="{ horizontal: 0, vertical: 10 }"
                        (anchorViewportLeave)="showPopup = false"
                        class="rounded"
                        #popup>
                    @if (media$ | async; as medias) {

                        <kendo-grid
                                [data]="gridView"
                                [groupable]="false"
                                [group]="groups"
                                [ngStyle]="{'width': attachmentWidth}"
                                (cellClick)="onCellClick($event)"
                                class="max-h-96 cursor-pointer overflow-auto rounded p-2.5"
                        >
                            <kendo-grid-column field="CollectionName" [hidden]="true">
                                <ng-template kendoGridGroupHeaderTemplate let-value="value">
                                    {{ value }}
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column [media]="'(max-width: ' + MAX_MOBILE_WIDTH + 'px)'">
                                <ng-template kendoGridCellTemplate let-media>
                                    <div class="flex w-full flex-col gap-2.5 p-2.5">
                                        <div class="flex w-full justify-between">
                                            <label for="original">{{'Original' | translate}}</label>
                                            <input type="checkbox" id="original" (click)="setVersion(media, 'original', $event)"
                                                   [checked]="media.SelectedVersion == 'original'">
                                            @if (media.PdfId != undefined) {
                                                <label for="pdf">{{'PDF' | translate}}</label>
                                                <input type="checkbox" id="pdf" (click)="setVersion(media, 'pdf', $event)"
                                                       [checked]="media.SelectedVersion == 'pdf'">
                                            }
                                        </div>
                                        <div class="flex w-full justify-between">
                                            <div>{{ 'Extension' | translate }}</div>
                                            <div>
                                                <bizz-extension-icon class="size-4 items-end"
                                                                     [extension]="getFileExtension(media.Extension)"></bizz-extension-icon>
                                            </div>
                                        </div>
                                        <div class="flex w-full justify-between">
                                            <div>{{ 'Title' | translate }}</div>
                                            <div>{{ media.OriginalFileName }}</div>
                                        </div>
                                        <div class="flex w-full justify-between">
                                            <div>{{ 'FileSize' | translate }}</div>
                                            <div>{{ media.FileSize }}</div>
                                        </div>


                                        <div class="flex w-full justify-between">
                                            <div>{{ 'Author' | translate }}</div>
                                            <div>{{ media.RegisteredBy }}</div>
                                        </div>

                                        <div class="flex w-full justify-between">
                                            <div>{{ 'Version' | translate }}</div>
                                            <div>{{ media.Version }}</div>
                                        </div>


                                        <div class="flex w-full justify-between">
                                            <div>{{ 'VersionDate' | translate }}</div>
                                            <div>{{ media.UploadTimestamp | date:'short' }}</div>
                                        </div>
                                    </div>
                                </ng-template>
                            </kendo-grid-column>

                            <kendo-grid-column [title]="'Original' | translate"
                                               [media]="'(min-width: ' + MAX_MOBILE_WIDTH + 'px)'" [width]="80">
                                <ng-template kendoGridCellTemplate let-media>
                                    <input type="checkbox" (click)="setVersion(media, 'original', $event)"
                                           [checked]="media.SelectedVersion == 'original'">
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column [title]="'PDF' | translate"
                                               [media]="'(min-width: ' + MAX_MOBILE_WIDTH + 'px)'" [width]="60">
                                <ng-template kendoGridCellTemplate let-media>
                                    @if (media.PdfId != undefined) {
                                        <input type="checkbox" (click)="setVersion(media, 'pdf', $event)"
                                               [checked]="media.SelectedVersion == 'pdf'">
                                    }
                                </ng-template>
                            </kendo-grid-column>

                            <kendo-grid-column [title]="'Extension' | translate" [width]="70"
                                               [media]="'(min-width: ' + MAX_MOBILE_WIDTH + 'px)'">
                                <ng-template kendoGridCellTemplate let-media>
                                    <bizz-extension-icon class="mx-4 size-4"
                                                         [extension]="getFileExtension(media.Extension)"></bizz-extension-icon>
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column [width]="200"
                                               field="OriginalFileName"
                                               [title]="'Title' | translate"
                                               [media]="'(min-width: ' + MAX_MOBILE_WIDTH + 'px)'"
                            ></kendo-grid-column>
                            <kendo-grid-column
                                    field="FileSize"
                                    [title]="'FileSize' | translate"
                                    [media]="'(min-width: ' + MAX_MOBILE_WIDTH + 'px)'"
                            ></kendo-grid-column>


                            <kendo-grid-column
                                    [media]="'(min-width: ' + MAX_MOBILE_WIDTH + 'px)'"
                                    field="Author"
                                    [title]="'RegisteredBy' | translate"
                            ></kendo-grid-column>

                            <kendo-grid-column
                                    [media]="'(min-width: ' + MAX_MOBILE_WIDTH + 'px)'"
                                    [width]="60"
                                    field="Version"
                                    [title]="'Version' | translate"
                            ></kendo-grid-column>


                            <kendo-grid-column
                                    [media]="'(min-width: ' + MAX_MOBILE_WIDTH + 'px)'"
                                    [title]="'VersionDate' | translate"
                            >
                                <ng-template kendoGridCellTemplate let-media>
                                    <span>{{ media.UploadTimestamp | date:'short' }}</span>
                                </ng-template>
                            </kendo-grid-column>
                        </kendo-grid>
                        <div class="flex flex-row items-center justify-end">
                            <button class="save m-4" (click)="applySelection(medias)">
                                {{ "add" | translate }}
                            </button>
                        </div>

                    }
                </kendo-popup>
            }
        }
    </div>
</div>

@if (attachments.length > 0 || fileUploads.length > 0) {
    <div class="mt-2 flex min-w-full max-w-full flex-row flex-wrap gap-2 text-xs">
        @for (attachment of attachments; track $index) {
            <div class="flex h-fit rounded bg-section">
                <div class="flex select-none items-center justify-between rounded border border-section p-2 cursor-pointer" (click)="downloadAttachment(attachment)" >
                    <bizz-extension-icon [size]="'extraSmall'" class="mx-2.5 flex h-4 w-4 items-center text-bold"
                                         [extension]="getFileExtension(attachment.fileName)"></bizz-extension-icon>
                    <p class="m-auto">{{ attachment.fileName }} <span>({{ formatFileSize(attachment.size) }})</span></p>
                    <bizz-icon (click)="removeAttachment(attachment.id)"
                               class="mx-2.5 h-4 w-4 cursor-pointer hover:text-red-500"
                               [class.!hidden]="readonly"
                               iconName="circle-xmark">
                    </bizz-icon>
                </div>
            </div>
        }
        @for (fileUpload of fileUploads; track $index) {
            @if (fileUpload.fileChunkUpload) {
                <div class="flex h-fit flex-wrap gap-2.5 rounded border border-blue-500/20 border-widget bg-section">
                    <div class="flex select-none items-center justify-between py-2">
                        <bizz-extension-icon class="mx-2.5 flex h-4 w-4 items-center"
                                             [extension]="'.' + getFileExtension(fileUpload.fileChunkUpload.fileName)"></bizz-extension-icon>
                        <div class="flex flex-col">
                            <p class="m-auto">{{ fileUpload.fileChunkUpload.fileName }}
                                <span>({{ formatFileSize(fileUpload.fileChunkUpload.size) }}
                                    )</span></p>
                            <div class="m-auto flex w-full justify-between gap-2.5">
                                <div class="m-auto h-2.5 w-full rounded-full bg-button">
                                    <div class="h-2.5 w-full rounded-full bg-blue-600"
                                         [ngStyle]="{'width': fileUpload.fileChunkUpload.progress + '%'}"></div>
                                </div>
                                <div class="ml-4">{{ (fileUpload.fileChunkUpload.progress.toFixed(0) + '%') }}</div>
                            </div>
                        </div>

                        <bizz-icon (click)="fileUpload.cancel()"
                                   class="mx-2.5 h-4 w-4 cursor-pointer hover:text-red-500"
                                   iconName="circle-xmark">
                        </bizz-icon>
                    </div>

                </div>
            }

        }
        <div class="flex">
            @if (emptyExtensionError) {
                <p class="text-danger">{{ "Info_EmptyExtension" | translate }}</p>
            }
            @if (sizeError) {
                <p class="text-danger">{{ "FileExceedsMaxSizeLimit" | translate }}</p>
            }
        </div>

    </div>
}